import React, {useEffect, useState} from 'react'
import styles from "../styles/Contactus.module.scss";
import {Layout} from "../components";
import numbers from "../images/number.svg";
import send from "../icons/send.svg";
import 'react-phone-input-2/lib/style.css'
import PhoneInput from 'react-phone-input-2'
import {doc, getFirestore, setDoc} from "firebase/firestore";

const Contactus = () => {

    const [user, setUser] = useState({});

    const [message, setMessage] = useState(null);
    const [notification, setNotification] = useState(null);
    const [className, setClassName] = useState(`${styles.alert} ${styles.info}`);

// Initialize Firebase

    const db = getFirestore();
    const pushRecords = async (e) => {
        e.preventDefault();
        try {
            const eventRef = doc(db, `events`, user.email);
            setDoc(eventRef, user.type ? user : {...user, type: 'demo'}, {merge: true})
            setClassName(`${styles.alert} ${styles.success}`);
            setMessage("Thanks for sharing your interest, our team will reach out to you shortly");
            setNotification({
                email: user.email,
                name: user.fname + " " + user.lname,
                company: user.company,
                type: user.type ? user.type : 'demo'
            })

        } catch (e) {
            setClassName(`${styles.alert} ${styles.warning}`);
            setMessage("We are facing issues in processing your request. Please drop a note to us at " +
                "support@cosmoneural.com")
            //console.error("Error adding document: ", e);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        if (message) {
            setTimeout(() => {
                setMessage(null);
            }, 3000);

        }
    }, [message]);


    return (<Layout classes={styles.body} notification={notification}>
        {message && <div className={styles.recoveryMessageOverlay}>
            <div className={className}>
                <span className={styles.closebtn}>&times;</span>
                {message}
            </div>
        </div>}
        <section className={styles.banner}>
            <div className={styles.imageLeft}>
                <img src={numbers} alt=""/>
            </div>
            <div className={styles.bannerContainer}>
                <div className={styles.bannerInner}>
                    <div className={styles.bannerItem1}>
                        Let’s get the conversation started.
                    </div>
                </div>
            </div>
            <div className={styles.imageRight}>
                <img src={numbers} alt=""/>
            </div>
        </section>
        <form className={styles.contactUs} onSubmit={(e) => pushRecords(e)}>
            <h4>How can we help you?</h4>
            <div className={styles.name}>
                <input required type='text' placeholder={'First Name'} value={user.fname}
                       onChange={(e) => setUser({...user, fname: e.target.value})}/>
                <input required type='text' placeholder={'Last Name'} value={user.lname}
                       onChange={(e) => setUser({...user, lname: e.target.value})}/>
            </div>
            <input required type='email' placeholder='Email' value={user.email}
                   onChange={(e) => setUser({...user, email: e.target.value})}/>
            <PhoneInput autoFormat={true} containerClass={styles.reactTelInput} name={'PhoneNo'}
                        inputClass={styles.formControl} inputStyle={{paddingLeft: '48px'}}
                        buttonClass={styles.flagDropdownButton} dropdownClass={styles.flagDropdown}
                        value={user.phone} country={'in'}
                        onChange={(e) => setUser({...user, phone: e})}
            />
            <input type='text' placeholder='Company' value={user.company}
                   onChange={(e) => setUser({...user, company: e.target.value})}/>
            <br/>
            <br/>
            <h4>What Are You Looking for?</h4>
            <div className={`${styles.selector} ${user.type === 'Design and Engineering' && styles.selected}`}
                 onClick={() => setUser({...user, type: 'Design and Engineering'})}><span/>
                <input checked={user.type === 'Design and Engineering'} onChange={(e) => {
                }} required type='radio' name='type'/>Design and Engineering
            </div>
            <div className={styles.name}>
                <div className={`${styles.selector} ${user.type === 'Careers' && styles.selected}`}
                     onClick={() => setUser({...user, type: 'Careers'})}><span/><input onChange={(e) => {
                }} checked={user.type === 'Careers'} required type='radio' name='type'/>Careers
                </div>
                <div className={`${styles.selector} ${user.type === 'Others' && styles.selected}`}
                     onClick={() => setUser({...user, type: 'Others'})}><span/><input onChange={(e) => {
                }} checked={user.type === 'Others'} required type='radio' name='type'/>Others
                </div>
            </div>
            <br/>
            <br/>
            <h4>Any other information</h4>
            <textarea placeholder={'Your Message'} value={user.message}
                      onChange={(e) => setUser({...user, message: e.target.value})}/>
            <button type='submit'>Send</button>
        </form>
        <div className={styles.demo}>
            <div className={styles.sendContainer}>
                <h5>We’d love to give you a demo</h5>
                <form onSubmit={pushRecords} className={styles.send}><input required type='email' value={user.email}
                                                                            onChange={(e) => setUser({
                                                                                ...user,
                                                                                email: e.target.value
                                                                            })}
                                                                            placeholder='Type your email address in here'/>
                    <button type='submit'><img
                        src={send} alt={"send"}/></button>
                </form>
            </div>
        </div>
    </Layout>)
}

export default Contactus;
